var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pinch-wrapper",style:(_vm.zoomStyles),on:{"touchstart":_vm.start,"touchmove":_vm.move,"touchend":_vm.end}},[_c('img',{ref:"image",staticClass:"pinch-img",attrs:{"src":_vm.src,"alt":_vm.alt,"referrerpolicy":"no-referrer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }